<template>
    <section class="elle-content-repeater">
        <component :is="eqTemplates[item.typeHandle]?.component || 'div'" v-for="item in data" :key="item.id" :data="item" />
    </section>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        data?: CmsItem[];
    }>(),
    {
        data: () => []
    }
);

const data = computed(() => props.data);

const elText = resolveComponent('ContentText');
const elMedia = resolveComponent('ContentMedia');
const elVideo = resolveComponent('ContentVideo');
const elGallery = resolveComponent('ContentGallery');

const eqTemplates: Record<string, { component: ReturnType<typeof resolveComponent> }> = {
    contentText: {
        component: elText
    },
    contentMedia: {
        component: elMedia
    },
    contentVideo: {
        component: elVideo
    },
    contentGallery: {
        component: elGallery
    }
};
</script>
